import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { AddressesActions } from '../addressesActions';
import { AddressesAction } from '../addressesActionType';
import Address from './Address';
import { IAddress } from './address.interface';

const mapStateToProps = (state: IReduxRootState) => {
    const countries = state.countries.countriesMap;
    return {
        addressTemplate: state.app.clientConfig.presentationConfig['address.template'],
        countries,
        challengerPid: state.app.appConfig.CHALLENGER_PIDS.ADDRESS_DEFAULT ?? '',
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AddressesAction>) => {
    return {
        deleteAddress: (addressUuid: string) => {
            dispatch(AddressesActions.deleteAddress(addressUuid));
        },
        setDefaultShipping: (address: IAddress, isShipping: boolean) => {
            dispatch(AddressesActions.setDefaultShipping(address, isShipping));
        },
    };
};

const AddressContainer = connect(mapStateToProps, mapDispatchToProps)(Address);

export default AddressContainer;
